/**
 * Svg Image React component
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import * as React from "react";

import SVG from "react-inlinesvg";

/**
 * Svg Image props
 */
export interface ISvgImageProps {
	/** Source */
	source: string;
}

/**
 * Svg Image component
 */
export const SvgImage: React.FunctionComponent<ISvgImageProps> = (props) => {
	return (
		<SVG
			src={props.source}
			cacheRequests={true}
			className="svg-image--ready"
			loader={<img src={props.source} alt="" className="svg-image--loading" />}
		/>
	);
};
